import { ProductListStateModel } from '../model/product-state.model';

export class SetProductList {
	static readonly type = '[Products] SetProductList';
	constructor(public productListStateModel: ProductListStateModel) {}
}
